import { Component, Input, OnInit } from '@angular/core';
import { UserInfo } from '../../../../lib/models/user.model';
import {
  AccessMatrixService,
  ModuleTypeEnum,
  RouteTypeEnum,
} from '../../../../lib/services/access-matrix.service';

interface MenuChild {
  id: string;
  routerLink: string;
  title: string;
  icon: string;
  state?: UserInfo[];
}

interface MenuElement {
  id: string;
  routerLink: string;
  title: string;
  icon: string;
  state?: UserInfo[];
  children?: MenuChild[];
}

@Component({
  selector: 'ms-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: false,
})
export class SideMenuComponent implements OnInit {
  @Input() userInfos: UserInfo[] = [];

  menuElements: MenuElement[] = [];

  constructor(private accessMatrixService: AccessMatrixService) {}

  ngOnInit() {
    const isDashboardAvailable: boolean =
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.DASHBOARD);
    const isDatabaseAvailable: boolean =
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.DATABASE);
    const isDatabaseUsersAvailable: boolean =
      this.accessMatrixService.isAvailableModule(
        RouteTypeEnum.DATABASE,
        ModuleTypeEnum.DATABASE_USER,
      );
    const isDatabaseGroupsAvailable: boolean =
      this.accessMatrixService.isAvailableModule(
        RouteTypeEnum.DATABASE,
        ModuleTypeEnum.DATABASE_GROUP,
      );
    const isReportingAvailable: boolean =
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.REPORTING);
    const isLicensesAvailable: boolean =
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.LICENSES);
    const isBannerAvailable: boolean =
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.BANNER);
    const isBatchAvailable: boolean =
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.BATCH);
    const isToolsAvailable: boolean =
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.TOOLS);

    const childrenOfDatabase: MenuChild[] = [];
    if (isDatabaseGroupsAvailable) {
      childrenOfDatabase.push({
        id: 'groups',
        icon: 'hub',
        title: 'Groupes',
        routerLink: './database/groups',
        state: this.userInfos,
      });
    }
    if (isDatabaseUsersAvailable) {
      childrenOfDatabase.push({
        id: 'users',
        icon: 'groups',
        title: 'Utilisateurs',
        routerLink: './database/users',
        state: this.userInfos,
      });
    }

    if (isDashboardAvailable) {
      this.menuElements.push({
        id: 'dashboard',
        routerLink: './dashboard',
        title: 'Tableau de bord',
        icon: 'dashboard',
        state: this.userInfos,
      });
    }

    if (isDatabaseAvailable) {
      this.menuElements.push({
        id: 'database',
        routerLink: './database',
        title: 'Base de données',
        icon: 'cloud',
        children: childrenOfDatabase,
      });
    }

    if (isReportingAvailable) {
      this.menuElements.push({
        id: 'reporting',
        routerLink: './reporting',
        title: 'Reporting',
        icon: 'insert_chart_outlined',
      });
    }

    if (isLicensesAvailable) {
      this.menuElements.push({
        id: 'licenses',
        routerLink: './licenses',
        title: 'Blocages actifs',
        icon: 'block',
      });
    }

    if (isBannerAvailable) {
      this.menuElements.push({
        id: 'banner',
        routerLink: './banner',
        title: 'Bandeau',
        icon: 'announcement',
      });
    }

    if (
      this.accessMatrixService.isAvailableModule(RouteTypeEnum.MS_LIGHT)
    ) {
      this.menuElements.push({
        id: 'ms-light',
        routerLink: './ms-light',
        title: 'MS Light',
        icon: 'list',
      });
    }

    if (isBatchAvailable) {
      this.menuElements.push({
        id: 'batch',
        routerLink: './batch',
        title: 'Batch',
        icon: 'batch_prediction',
      });
    }

    if (isToolsAvailable) {
      this.menuElements.push({
        id: 'tools',
        routerLink: './tools',
        title: 'Outils',
        icon: 'build',
      });
    }
  }
}
